export var siteType = 12; //For fp gold 12
export var product = 2;
export var regularJoinType = 1;
export var phoneJoinType = 2;
export var emailJoinType = 3;



// WEBPACK FOOTER //
// ./src/constants/configMap.js